import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const CoachMarkWrapper = styled.div`
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 20;
  width: 470px;
  max-width: calc(100vw - 40px);
  animation: ${fadeIn} 0.3s ease-out;
`;

export const CoachMarkBubble = styled.div`
  position: relative;
  background: linear-gradient(
    135deg,
    rgba(233, 212, 255, 0.3) 0%,
    ${theme.whiteText} 40%
  );
  background-color: ${theme.whiteText};
  border-radius: 12px;
  padding: 17px;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  filter: drop-shadow(0px 4px 10px rgba(73, 73, 73, 0.21));

  &::before {
    content: "";
    position: absolute;
    top: -10px;
    right: 80px;
    width: 0;
    height: 0;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 14px solid ${theme.whiteText};
  }
`;

export const CoachMarkIcon = styled.img`
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const CoachMarkContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CoachMarkTitle = styled.div`
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CoachMarkSubtitle = styled.div`
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CoachMarkClose = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  align-self: flex-start;
  color: ${theme.greyText6};

  &:hover {
    color: ${theme.greyText};
  }
`;
